import {useEffect} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import {apiGet} from '../axiosConfig';

export const useMaintenanceRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;

    const checkStatus = async () => {
      try {
        const res = await apiGet('/v1/maintenance-status');
        if (
          res.data.is_in_maintenance &&
          location.pathname !== '/maintenance'
        ) {
          navigate('/maintenance');
        } else if (
          !res.data.is_in_maintenance &&
          location.pathname === '/maintenance'
        ) {
          // If maintenance is over, redirect to sign-in or home page
          navigate('/sign-in');
        }
      } catch (err) {
        console.error('Maintenance check failed:', err);
      }
    };

    checkStatus(); // check immediately on load

    // Only poll every 10 seconds if on /maintenance page
    if (location.pathname === '/maintenance') {
      interval = setInterval(checkStatus, 10000);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [navigate, location]);
};
